import { motion } from "framer-motion";
import { SiteLayout } from "@/components/site/SiteLayout";
import { Link } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";

const PolitiqueCookiesPage = () => {
  return (
    <SiteLayout>
      <SEOHead
        title="Politique de Cookies"
        description="Politique de cookies du site Autosur Montreuil-sous-Bois. Informations sur l'utilisation des cookies et vos droits."
        path="/politique-cookies"
        noindex
      />
      {/* Hero */}
      <section className="relative py-20 bg-gradient-to-br from-autosur-navy to-autosur-blue overflow-hidden">
        <div className="container mx-auto px-6 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center max-w-3xl mx-auto"
          >
            <span className="text-autosur-red font-heading font-semibold tracking-widest text-sm mb-4 block">
              INFORMATIONS LÉGALES
            </span>
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-white mb-4">
              Politique des cookies
            </h1>
            <p className="font-body text-white/70 text-sm">
              Mise à jour le 26/08/2024
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-background">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="max-w-4xl mx-auto prose prose-lg"
          >
            {/* Section 1 */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl font-bold text-autosur-navy mb-4">
                1. DÉFINITION
              </h2>
              <p className="font-body text-muted-foreground leading-relaxed">
                Les cookies sont de petits fichiers texte qui sont déposés sur le Terminal de l'utilisateur utilisé pour la consultation et la navigation sur le Site (ordinateur, tablette ou tout autre appareil connecté à Internet) et qui sont gérés par son navigateur Internet.
              </p>
              <p className="font-body text-muted-foreground leading-relaxed mt-4">
                L'utilisateur pourra désactiver ces cookies par l'intermédiaire des paramètres figurant au sein de son navigateur.
              </p>
            </div>

            {/* Section 2 */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl font-bold text-autosur-navy mb-4">
                2. FINALITÉS
              </h2>
              <p className="font-body text-muted-foreground leading-relaxed mb-6">
                L'utilisateur est informé que lors de ses visites sur le Site, cinq (5) catégories principales de cookies peuvent s'installer sur son navigateur notamment pour les raisons suivantes :
              </p>

              {/* 2.1 */}
              <div className="mb-6 pl-4 border-l-4 border-autosur-blue">
                <h3 className="font-heading text-xl font-semibold text-autosur-navy mb-3">
                  2.1 Cookies strictement nécessaires à l'utilisation du Site
                </h3>
                <p className="font-body text-muted-foreground leading-relaxed mb-3">
                  Ces cookies permettent :
                </p>
                <ul className="list-disc list-inside font-body text-muted-foreground space-y-2 ml-4">
                  <li>l'utilisation des fonctionnalités principales du Site,</li>
                  <li>la mémorisation des préférences d'affichage du Terminal de l'utilisateur (langue, paramètres d'affichage) selon la charte graphique, le type de Terminal et les logiciels de visualisation ou de lecture que l'utilisateur utilise (type de navigateur Internet), et d'en tenir compte lors des visites ultérieures de l'utilisateur,</li>
                  <li>la liaison entre-elles des différentes pages consultées pour assurer à l'utilisateur une navigation fluide,</li>
                  <li>l'établissement de statistiques et le comptage de fréquentation et d'utilisation des différentes pages et rubriques du Site (nombre de visite, de pages vues, le parcours des utilisateurs sur le Site, fréquence de retour sur le Site, etc.) pour améliorer le fonctionnement, de manière anonyme.</li>
                </ul>
                <p className="font-body text-muted-foreground leading-relaxed mt-3 italic">
                  La fourniture de ces services ne requiert pas de consentement exprès.
                </p>
              </div>

              {/* 2.2 */}
              <div className="mb-6 pl-4 border-l-4 border-autosur-blue">
                <h3 className="font-heading text-xl font-semibold text-autosur-navy mb-3">
                  2.2 Cookies de services et de personnalisation
                </h3>
                <p className="font-body text-muted-foreground leading-relaxed mb-3">
                  Ces cookies amènent des fonctionnalités supplémentaires qui sont susceptibles d'intéresser l'utilisateur, sans pour autant être indispensable à l'utilisation de base du Site. Ces cookies permettent à l'utilisateur par exemple :
                </p>
                <ul className="list-disc list-inside font-body text-muted-foreground space-y-2 ml-4">
                  <li>la géolocalisation de l'utilisateur afin de lui proposer des résultats liés à ses besoins (par exemple : affichages de centres situés à proximité de l'utilisateur). Leur durée de vie n'excède pas le temps de connexion de votre navigateur, et aucune information géographique n'est collectée et enregistrée nominativement.</li>
                </ul>
                <p className="font-body text-muted-foreground leading-relaxed mt-3 italic">
                  Pour bénéficier de ces services, un consentement exprès est nécessaire.
                </p>
              </div>

              {/* 2.3 */}
              <div className="mb-6 pl-4 border-l-4 border-autosur-blue">
                <h3 className="font-heading text-xl font-semibold text-autosur-navy mb-3">
                  2.3 Cookies publicitaires
                </h3>
                <p className="font-body text-muted-foreground leading-relaxed mb-3">
                  Ces cookies collectent des informations sur vos habitudes de navigation dans le but de vous présenter des publicités adaptées à vos centres d'intérêt.
                </p>
                <p className="font-body text-muted-foreground leading-relaxed mb-3">
                  Ces cookies enregistrent votre visite sur notre Site, les pages que vous avez visitées et les liens que vous avez suivis ainsi que votre navigation en dehors de notre Site. Ils sont également utilisés pour limiter le nombre de fois où vous voyez une publicité ainsi que pour mesure l'efficacité des campagnes publicitaires.
                </p>
                <p className="font-body text-muted-foreground leading-relaxed mb-3">
                  Ils sont généralement placés par des tiers avec notre permission.
                </p>
                <p className="font-body text-muted-foreground leading-relaxed mb-3">
                  Le refus de ce type de cookie n'a pas d'impact sur l'utilisation de notre Site et n'empêche pas l'affichage de la publicité sur notre Site ou sur Internet de manière générale.
                </p>
                <p className="font-body text-muted-foreground leading-relaxed italic">
                  Pour bénéficier de ces services, un consentement exprès est nécessaire.
                </p>
              </div>

              {/* 2.4 */}
              <div className="mb-6 pl-4 border-l-4 border-autosur-blue">
                <h3 className="font-heading text-xl font-semibold text-autosur-navy mb-3">
                  2.4 Les cookies analytiques / mesure d'audience
                </h3>
                <p className="font-body text-muted-foreground leading-relaxed mb-3">
                  Il s'agit des cookies qui nous permettent de connaître l'utilisation et les performances de notre site, d'établir des statistiques, des volumes de fréquentation et d'utilisation des divers éléments composant nos sites (rubriques et contenus visités, parcours), nous permettant d'améliorer l'intérêt et l'ergonomie de nos services (par exemple, les pages les plus souvent consultées, recherches des internautes dans notre moteur de recherche...). Les informations recueillies par ces cookies sont complètement anonymes. Ils ne réunissent aucune information qui pourrait permettre de vous identifier personnellement.
                </p>
                <p className="font-body text-muted-foreground leading-relaxed mb-3">
                  Pour la réalisation de ces différentes études, nous utilisons les tags Google Analytics.
                </p>
                <p className="font-body text-muted-foreground leading-relaxed italic">
                  Pour bénéficier de ces services, un consentement exprès est nécessaire.
                </p>
              </div>

              {/* 2.5 */}
              <div className="mb-6 pl-4 border-l-4 border-autosur-blue">
                <h3 className="font-heading text-xl font-semibold text-autosur-navy mb-3">
                  2.5 Les cookies de partage (liens sociaux)
                </h3>
                <p className="font-body text-muted-foreground leading-relaxed mb-3">
                  Dans le cadre de notre communication sur les réseaux sociaux, nous pouvons être amenés à utiliser des cookies tiers tels que Facebook et Instagram.
                </p>
                <p className="font-body text-muted-foreground leading-relaxed mb-3">
                  Ces cookies permettent l'obtention de rapports détaillés liés à d'éventuelles campagnes, de suivre le cheminement des utilisateurs des réseaux sociaux lors des visites de nos sites Internet. La traçabilité est assurée au travers d'un mécanisme de balises, fourni par les acteurs des réseaux sociaux.
                </p>
                <p className="font-body text-muted-foreground leading-relaxed mb-3">
                  Ces cookies assurent le suivi de certains événements ou de proposer des offres ou services de recommercialisation. L'ensemble des informations réunies par le biais des balises de collecte respectent les politiques de confidentialité des réseaux sociaux en matière d'utilisation des balises, en plus d'être utilisé conformément à la politique de confidentialité de SECTA.
                </p>
                <p className="font-body text-muted-foreground leading-relaxed mb-4">
                  Les sites Internet de SECTA ne recueilleront, ne garderont de données nominatives et personnelles des utilisateurs.
                </p>
                <p className="font-body text-muted-foreground leading-relaxed mb-2">
                  Nous détaillons ci-dessous les démarches de refus de ces cookies :
                </p>
                <ul className="list-disc list-inside font-body text-muted-foreground space-y-2 ml-4">
                  <li>
                    <a href="https://www.facebook.com/policies/cookies/" target="_blank" rel="noopener noreferrer" className="text-autosur-blue hover:text-autosur-navy underline">
                      Politique d'utilisation des cookies Facebook
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/full_data_use_policy" target="_blank" rel="noopener noreferrer" className="text-autosur-blue hover:text-autosur-navy underline">
                      Politique des données Facebook
                    </a>
                  </li>
                  <li>
                    <a href="https://fr-fr.facebook.com/help/instagram/1896641480634370" target="_blank" rel="noopener noreferrer" className="text-autosur-blue hover:text-autosur-navy underline">
                      Politique d'utilisation des cookies Instagram
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Section 3 */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl font-bold text-autosur-navy mb-4">
                3. DURÉE DE CONSERVATION
              </h2>
              <p className="font-body text-muted-foreground leading-relaxed">
                Lors de la navigation de l'utilisateur sur le Site (autres que les données d'informations de connexion, des pages consultées et adresses IP), la durée de conservation des cookies est de <strong>6 mois maximum</strong> à compter de leur dernier dépôt.
              </p>
            </div>

            {/* Section 4 */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl font-bold text-autosur-navy mb-4">
                4. CONSENTEMENT
              </h2>
              <p className="font-body text-muted-foreground leading-relaxed">
                Afin de gérer la dépose des cookies de notre Site, l'utilisateur peut gérer les paramètres sur le Site en cliquant sur le lien intitulé « Gérer mes consentements » en bas de page.
              </p>
              <p className="font-body text-muted-foreground leading-relaxed mt-3">
                Ce consentement a une durée de validité de <strong>6 mois</strong>.
              </p>
            </div>

            {/* Section 5 */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl font-bold text-autosur-navy mb-4">
                5. COMMENT ACCEPTER/REFUSER L'UTILISATION GLOBALE DE COOKIES ?
              </h2>

              <h3 className="font-heading text-xl font-semibold text-autosur-navy mb-3 mt-6">
                a. Paramétrer le navigateur
              </h3>
              <p className="font-body text-muted-foreground leading-relaxed mb-3">
                Vous pouvez à tout moment choisir de désactiver ces cookies. Votre navigateur peut également être paramétré pour vous signaler les cookies qui sont déposés dans votre ordinateur et vous demander de les accepter ou non. Vous pouvez accepter ou refuser les cookies au cas par cas ou bien les refuser systématiquement une fois pour toutes.
              </p>
              <p className="font-body text-muted-foreground leading-relaxed mb-4">
                Nous vous rappelons que le paramétrage est susceptible de modifier les conditions d'accès aux services nécessitant l'utilisation de cookies. Si le navigateur est configuré de manière à refuser l'ensemble des cookies, l'utilisateur ne pourra pas par exemple effectuer d'achats ou profiter de fonctions essentielles du Site. Le paramétrage est spécifique à chaque navigateur.
              </p>

              <div className="bg-autosur-grey-light rounded-xl p-6">
                <ul className="space-y-3 font-body text-muted-foreground">
                  <li>
                    <strong>Pour Internet Explorer™ :</strong> ouvrez le menu « Outils », puis sélectionnez « Options internet » ; cliquez sur l'onglet « Confidentialité » puis l'onglet « Avancé » choisissez le niveau souhaité.{" "}
                    <a href="https://support.microsoft.com/fr-fr/windows/supprimer-et-g%C3%A9rer-les-cookies-168dab11-0753-043d-7c16-ede5947fc64d" target="_blank" rel="noopener noreferrer" className="text-autosur-blue hover:text-autosur-navy underline">
                      En savoir plus
                    </a>
                  </li>
                  <li>
                    <strong>Pour Firefox™ :</strong> ouvrez le menu « Outils », puis sélectionnez « Options » ; cliquez sur l'onglet « Vie privée » puis choisissez les options souhaitées.{" "}
                    <a href="https://support.mozilla.org/fr/kb/protection-renforcee-contre-pistage-firefox-ordinateur" target="_blank" rel="noopener noreferrer" className="text-autosur-blue hover:text-autosur-navy underline">
                      En savoir plus
                    </a>
                  </li>
                  <li>
                    <strong>Pour Chrome™ :</strong> ouvrez le menu de configuration (logo clé à molette), puis sélectionnez « Options » ; cliquez sur « Options avancées » puis dans la section « Confidentialité », cliquez sur « Paramètres de contenu », et choisissez les options souhaitées.{" "}
                    <a href="https://support.google.com/chrome/answer/95647?hl=fr" target="_blank" rel="noopener noreferrer" className="text-autosur-blue hover:text-autosur-navy underline">
                      En savoir plus
                    </a>
                  </li>
                  <li>
                    <strong>Pour Safari™ :</strong> choisissez « Safari &gt; Préférences » puis cliquez sur « Sécurité » ; Dans la section « Accepter les cookies » choisissez les options souhaitées.{" "}
                    <a href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-autosur-blue hover:text-autosur-navy underline">
                      En savoir plus
                    </a>
                  </li>
                  <li>
                    <strong>Pour Opera™ :</strong> ouvrez le menu « Outils » ou « Réglages », puis sélectionnez « Supprimer les données privées » ; cliquez sur l'onglet « Options détaillées », puis choisissez les options souhaitées.{" "}
                    <a href="https://help.opera.com/en/latest/web-preferences/#cookies" target="_blank" rel="noopener noreferrer" className="text-autosur-blue hover:text-autosur-navy underline">
                      En savoir plus
                    </a>
                  </li>
                </ul>
              </div>

              <p className="font-body text-muted-foreground leading-relaxed mt-4">
                Retrouvez plus d'informations sur l'utilisation des cookies sur le{" "}
                <a href="https://www.cnil.fr/fr/cookies-et-autres-traceurs" target="_blank" rel="noopener noreferrer" className="text-autosur-blue hover:text-autosur-navy underline">
                  site de la CNIL
                </a>.
              </p>

              <h3 className="font-heading text-xl font-semibold text-autosur-navy mb-3 mt-6">
                b. Utiliser une plateforme de gestion de cookies
              </h3>
              <p className="font-body text-muted-foreground leading-relaxed">
                L'utilisateur peut décider de refuser la publicité comportementale en utilisant l'outil fourni sur ce site :{" "}
                <a href="http://www.youronlinechoices.com/fr/" target="_blank" rel="noopener noreferrer" className="text-autosur-blue hover:text-autosur-navy underline">
                  http://www.youronlinechoices.com/fr/
                </a>. Les cookies déposés en cas d'utilisation des boutons de partage sont également inclus dans cette plateforme.
              </p>
            </div>

            {/* Section 6 */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl font-bold text-autosur-navy mb-4">
                6. QUESTIONS – CONTACT
              </h2>
              <p className="font-body text-muted-foreground leading-relaxed mb-4">
                Pour toutes questions ou commentaires relatifs à la Politique de Données Personnelles ou à la façon dont nous procédons à la collecte et au traitement des cookies, l'utilisateur peut contacter :
              </p>
              <div className="bg-autosur-grey-light rounded-xl p-6">
                <p className="font-heading font-bold text-autosur-navy mb-2">SECTA AUTOSUR</p>
                <p className="font-body text-muted-foreground">Délégué à la protection des données</p>
                <p className="font-body text-muted-foreground mt-3">
                  20 ter, rue de Bezons, CS60030<br />
                  92415 Courbevoie Cedex
                </p>
                <p className="font-body text-muted-foreground mt-3">
                  E-mail :{" "}
                  <a href="mailto:autosur.montreuil@gmail.com" className="text-autosur-blue hover:text-autosur-navy underline">
                    autosur.montreuil@gmail.com
                  </a>
                </p>
              </div>
            </div>

            {/* Back link */}
            <div className="pt-8 border-t border-gray-200">
              <Link 
                to="/" 
                className="inline-flex items-center gap-2 text-autosur-blue hover:text-autosur-navy font-heading font-semibold transition-colors"
              >
                ← Retour à l'accueil
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </SiteLayout>
  );
};

export default PolitiqueCookiesPage;
